import { useDispatch, useSelector } from "react-redux";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField, CircularProgress } from "@mui/material";
import { useEffect, useCallback, forwardRef, Fragment, useState } from "react";
import { styled } from "@mui/system";
import { User } from "../../app/slices/userSlice";
import useDebounce from "../hooks/useDebounce";

export const SelectUser = forwardRef((props, ref) => {
  const user = useSelector((state) => state.user.usersList);
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const search = useDebounce(inputValue.trim(), 500);
  // spinner covers the debounce wait too, not just the request
  const searching = user.loading || inputValue.trim() !== search;

  // One Redux list backs every instance of this selector, so a search in a
  // sibling instance replaces the options this one resolved its value from.
  // Remember what was picked here and fall back to it.
  const [picked, setPicked] = useState(null);

  const fetchOptions = useCallback(() => {
    dispatch(
      User.getAllList({
        user_type: props.usertype ? props.usertype : "",
        search,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, search, props.usertype]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    borderBottom: "1px solid #e0e0e0",
    color: "white",
    backgroundColor: theme.palette.primary.main,
  }));
  const GroupItems = styled("ul")({
    padding: 0,
  });

  return (
    <Autocomplete
      ref={ref}
      options={user.data || []}
      {...props}
      filterOptions={(x) => x}
      value={props.value ?? picked}
      onChange={(event, newValue, reason) => {
        setPicked(newValue);
        props.onChange?.(event, newValue, reason);
      }}
      onOpen={(event) => {
        // The shared list may hold a sibling's results; get ours back.
        fetchOptions();
        props.onOpen?.(event);
      }}
      loading={searching}
      onInputChange={(event, value, reason) => {
        if (reason === "input" || reason === "clear") setInputValue(value || "");
        props.onInputChange?.(event, value, reason);
      }}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option?.id == value?.id}
      renderInput={(params) => (
        <TextField
          required={props.requird}
          error={props.error}
          helperText={props.helperText}
          {...params}
          label={props.label ?? "اسم المستخدم"}
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {searching ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
        />
      )}
      renderGroup={(params, key) => (
        <li key={params.key}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
    />
  );
});
